import { MapIcon, ClipboardListIcon, TableIcon, FolderTreeIcon, CompassIcon } from 'lucide-react'

export const extraTools = [
  {
    icon: MapIcon,
    title: '30+ TCM Diagnostic Decision Tools',
    text: 'A collection of visual decision maps, troubleshooting routes, and structured worksheets designed to help you organize different TCM situations.',
  },
  {
    icon: ClipboardListIcon,
    title: 'Professional Workshop Checklists',
    text: 'Preparation, identification, documentation, file-management, and verification checklists to help you avoid relying entirely on memory.',
  },
  {
    icon: TableIcon,
    title: 'TCM Diagnostic Reference Matrices',
    text: 'Quick-reference tables to organize symptoms, available information, potential investigation paths, and the next decision.',
  },
  {
    icon: FolderTreeIcon,
    title: 'TCM File Organization System',
    text: 'A practical structure for documenting original files, backups, versions, vehicle information, and job records.',
  },
  {
    icon: CompassIcon,
    title: 'Visual TCM Decision Maps',
    text: 'One-page references designed to be consulted at your workbench or on your phone.',
  },
]
